import { useTranslator } from "../../i18n/context.js";
import { renderElement } from "../../utils/use-render.js";
import { useInputIndicatorRoot } from "../input-indicator/use-input-indicator-root.js";
import { StatusIndicatorProvider } from "./context.js";
import { StatusIndicatorCore, StatusIndicatorDataAttrs, createInputIndicatorLabels } from "@videojs/core";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/status-indicator/root.tsx
const StatusIndicatorRoot = forwardRef(function StatusIndicatorRoot(componentProps, forwardedRef) {
	const { render, className, style, actions, closeDelay, ...elementProps } = componentProps;
	const translator = useTranslator();
	const { elementRef, present, state } = useInputIndicatorRoot(() => new StatusIndicatorCore(), {
		actions,
		closeDelay,
		labels: createInputIndicatorLabels(translator)
	}, { replayOnUpdate: false });
	if (!present) return null;
	return /* @__PURE__ */ jsx(StatusIndicatorProvider, {
		value: { state },
		children: renderElement("div", {
			render,
			className,
			style
		}, {
			state,
			stateAttrMap: StatusIndicatorDataAttrs,
			ref: [forwardedRef, elementRef],
			props: [elementProps]
		})
	});
});
//#endregion
export { StatusIndicatorRoot };

//# sourceMappingURL=root.js.map